import { useEffect, useState } from "react";
import { queryTokenExConfig } from "../services/dataQueries";

export function useTokenConfig() {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading");

  const loadConfigs = async () => {
    try {
      const results = await queryTokenExConfig();

      setData(results);
      setStatus("success");
    } catch (error) {
      setStatus("error");
    }
  };

  const refresh = () => {
    setStatus("loading");
    loadConfigs();
  };

  useEffect(() => {
    // Start loading the configs initially
    if (!data) {
      loadConfigs();
    }
  }, []);

  return {
    data,
    status,
    refresh
  };
}
